import { Typography } from "@mui/material"
import { Box } from "@mui/system"
import React from "react"
import { gestioneLunghezzaFrasi } from "../../../../functions/gestioneLunghezzaFrasi"


export default function InfoZona({ infoElement }) {

    return (
        <React.Fragment>
            <Box sx={{ paddingBottom: "5px", backgroundColor: '#3e6bb4', color: '#F9F9FA' }}>
                <Typography sx={{ display: "flex", alignItems: "center", justifyContent: "center", paddingTop: "5px" }}><b>{infoElement.sigla}</b></Typography>
                <Typography sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}><i>{gestioneLunghezzaFrasi(infoElement.denominazione)}</i></Typography>
            </Box>
        </React.Fragment>
    )
}